import {DG_axios} from "../../../../custom/axios";
import jwtDecode from "jwt-decode";
import {DG_axiosNormal} from "../../../../custom/axios/normal";
import {store} from "../../../../redux/store/store";
import {logoutStart} from "../../../../redux/actions/login/actions";
import Cookies from "js-cookie";
import {BASE_PATH} from "../../../../custom/axios/config/Url";

const baseUrl = "/dogoo/account-rest/v2.0"

export const getAllAccounts = async (filter, page, pageSize, search, sort) => {
    const response = await DG_axios.get(baseUrl + "/accounts", {
        params: {
            filter,
            page,
            pageSize,
            search,
            sort
        }
    })
    return response?.data || []
}

export const getAccountById = async (employeeId) => {
    const response = await DG_axios.get(baseUrl + "/accounts" + "/" + employeeId)
    return response?.data || []
}
export const changeStatusAccountApi = async (accountId, status) => {
    const response = await DG_axios.put(`${baseUrl}/accounts/${accountId}/approval`, {status: status})
    return response?.data || []
}

export const changePassword = async (accountId, params) => {
    const response = await DG_axios.put(`${baseUrl}/accounts/${accountId}/update-password`, params)
    return response?.data || []
}
export const changeEmail = async (accountId, params) => {
    const response = await DG_axios.put(`${baseUrl}/accounts/${accountId}/update-email`, params)
    return response?.data || []
}

export const changeAvatar = async (accountId, params) => {
    const response = await DG_axios.put(`${baseUrl}/accounts/${accountId}/avatar`, params)
    return response?.data || []
}

export const getAvatarByAccountId = async (accountId) => {
    const response = await DG_axiosNormal.get(`${baseUrl}/accounts/${accountId}/avatar`)
    return response?.data || []
}


export const getMe = () => {
    try {

        const accessToken = Cookies.get("accessToken");
        return jwtDecode(accessToken);
    } catch (e) {
        store.dispatch(logoutStart())
    }
}

export async function addAccount(account) {
    const response = await DG_axios.post(baseUrl + "/accounts", account)
    return response?.data || []
}

export const checkEnv = (dispatch) => {
    const env = BASE_PATH.replaceAll("https://", "")
        .replaceAll("/o", "")
        .replaceAll("http://", "")
        .replaceAll("/o/", "")
        .replaceAll(":8080", "")
    if (getMe()?.env && getMe()?.env !== env){
        dispatch(logoutStart())
    }
}
